import { useState } from 'react';
import { Undo2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { PcmpChannel } from '../../types/pcmpProposal.types';
import { PcmpReturnPaymentDialog } from './PcmpReturnPaymentDialog';

interface PcmpReturnPaymentButtonProps {
  proposalId: number;
  refNo: string;
  channel: PcmpChannel;
  /** The API's canAccountsReturn / canMarketingReturn; false hides the button. */
  canReturn: boolean;
  label?: string;
}

/** Admin / MIS's Return of one payout, all or part, opening its dialog. */
export function PcmpReturnPaymentButton({
  proposalId,
  refNo,
  channel,
  canReturn,
  label = 'Return',
}: PcmpReturnPaymentButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  // The dialog outlives the capability: a full return closes the option, and a
  // refused one must stay readable.
  if (!canReturn && !isOpen) return null;

  return (
    <>
      {canReturn ? (
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={() => setIsOpen(true)}
          className="gap-1.5"
        >
          <Undo2 className="size-3.5" />
          {label}
        </Button>
      ) : null}
      {/* Mounted only while open, so it starts empty. */}
      {isOpen ? (
        <PcmpReturnPaymentDialog
          target={{ proposalId, refNo, channel }}
          onClose={() => setIsOpen(false)}
        />
      ) : null}
    </>
  );
}
